import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getUlxVisitorId } from '../../utils/CookieUtil';

export const Pendo = (props) => {
    const {
        experiments,
        isFrboFlow,
        hydrationComplete,
        locale,
        isLoggedIn
    } = props;

    if (typeof window !== 'object') return null;

    const [isPendoInitialized, setIsPendoInitialized] = useState(false);
    useEffect(() => {
        if (hydrationComplete && !isPendoInitialized) {
            // eslint-disable-next-line no-unused-expressions
            window?.pendo?.initialize({
                visitor: {
                    id: !isLoggedIn ? 'VISITOR-UNIQUE-ID' : getUlxVisitorId(),
                    flow: isFrboFlow ? 'VR' : 'CL',
                    locale,
                    experiments: experiments.filter(experiment => experiment.value !== 0).map(e => e.name).join(',')
                }
            });
            setIsPendoInitialized(true);
        }
    }, [hydrationComplete]);

    return null;
};

Pendo.propTypes = {
    experiments: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
        name: PropTypes.string
    })).isRequired,
    isFrboFlow: PropTypes.bool.isRequired,
    hydrationComplete: PropTypes.bool.isRequired,
    locale: PropTypes.string.isRequired,
    isLoggedIn: PropTypes.bool.isRequired
};

/* istanbul ignore next */
export const mapStateToProps = (state) => {
    const { app, hydration } = state;
    const {
        experiments, features, locale, isLoggedIn
    } = app;
    const { hydrationComplete } = hydration;
    return {
        isLoggedIn,
        experiments,
        isFrboFlow: features.isFrboFlow,
        hydrationComplete,
        locale: locale.canonical
    };
};
Pendo.displayName = 'Pendo';
const PendoComponent = connect(mapStateToProps)(Pendo);
export default PendoComponent;
